var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"snapshots"}},[_c('p',[_vm._v("Traveler Snapshots")]),_c('div',{staticClass:"ig"},[_c('ImagesBoard',{attrs:{"columns":2,"tag":_vm.tag,"loadMore":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }